import { render, staticRenderFns } from "./ControlPanelTimer.vue?vue&type=template&id=45b88832"
import script from "./ControlPanelTimer.vue?vue&type=script&lang=js"
export * from "./ControlPanelTimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports